import { ref } from 'vue'

export function useProcess () {
  const showProcess = ref(false)
  const processStep = ref([
    {
      step: 1,
      status: 0, // 0 等待, 1 处理中, 2 完成
      text: 'Image recognition successful'
    },
    {
      step: 2,
      status: 0, // 0 等待, 1 处理中, 2 完成
      text: 'Analyzing products for you'
    },
    {
      step: 3,
      status: 0, // 0 等待, 1 处理中, 2 完成
      text: 'selecting by business insights'
    }
  ]) 

  return { 
    showProcess,
    processStep
  }
}